import { useNuxtApp } from '#app'

export enum AnalyticsEventKey {
  LaunchFirstTime = 'Launch_first_time',
  LandingPageViewed = 'Landing_page_viewed',
  PricingPageViewed = 'Pricing_page_viewed',
  DownloadPageViewed = 'Download_page_viewed',
  PartnersPageViewed = 'Partners_page_viewed',
  BlogPageViewed = 'Blog_page_viewed',
  FAQPageViewed = 'FAQ_page_viewed',
  ContactSupportInitiated = 'Contact_support_initiated',
  RefferalPageViewed = 'Refferal_page_viewed',
}

export function eventTracker(event: string, data?: Record<string, any>) {
  if (!import.meta.client) return;

  const nuxtApp = useNuxtApp();
  const $mixpanel = nuxtApp.$mixpanel as any;
  const $amplitude = nuxtApp.$amplitude as any;

  if (!(Object.values(AnalyticsEventKey) as string[]).includes(event)) {
    console.warn(`[Analytics] Событие "${event}" не входит в список допустимых`);
    return;
  }

  try {
    $mixpanel?.track?.(event, data)
  } catch (e) {
    console.warn('[Mixpanel] Ошибка при отправке события:', e)
  }

  try {
    $amplitude?.track?.(event, data)
  } catch (e) {
    console.warn('[Amplitude] Ошибка при отправке события:', e)
  }
};

export function identifyUser(userId: string, userProperties?: Record<string, any>) {
  if (!import.meta.client) return;

  const nuxtApp = useNuxtApp();
  const $mixpanel = nuxtApp.$mixpanel as any;
  const $amplitude = nuxtApp.$amplitude as any;

  $mixpanel?.identify?.(userId);
  if (userProperties) {
    $mixpanel?.people?.set?.(userProperties);
  }

  $amplitude?.setUserId?.(userId);
  if (userProperties) {
    // Dynamically import amplitude only when identifying users (rare operation)
    import('@amplitude/analytics-browser').then(({ Identify }) => {
      const identify = new Identify();
      for (const [key, value] of Object.entries(userProperties)) {
        identify.set(key, value);
      }
      $amplitude?.identify?.(identify);
    }).catch(() => {});
  }
}
